import api from "@/lib/axios";

export interface RoleScopeRef {
  role: string;
  scope_type: "global" | "country" | "city" | "zone" | "franchise";
  scope_reference_id: number | null;
}

export interface UnifiedScope {
  source: "franchise_owner" | "internal_team";
  is_unrestricted: boolean;
  country_ids: number[];
  city_ids: number[];
  franchise_entity_id: number | null;
  franchise_entity_name: string | null;
  franchise_tier: string | null;
  franchise_tier_display: string | null;
  franchise_tier_level: number | null;
  role_scopes: RoleScopeRef[];
}

export interface MyScopeResponse {
  scope: UnifiedScope | null;
}

export async function fetchMyScope(): Promise<MyScopeResponse> {
  return api.get<MyScopeResponse>("/rbac/me/scope/");
}
